import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      component: resolve => require(['@/components/companyTransfer/index.vue'], resolve),
      meta: {
        title: '首页'
      },
    },
    {
      path: '/list',
      component: resolve => require(['@/components/companyTransfer/list.vue'], resolve),
      meta: {
        title: '流程'
      },
    },
    {
      path: '/companyInfo',
      component: resolve => require(['@/components/companyTransfer/companyInfo.vue'], resolve),
      meta: {
        title: '出售信息'
      },
    },
    {
      path: '/detail',
      component: resolve => require(['@/components/companyTransfer/detail.vue'], resolve),
      meta: {
        title: '公司详情'
      },
    },
    {
      path: '/companyCar',
      component: resolve => require(['@/components/companyTransfer/companyCar.vue'], resolve),
      meta: {
        title: '购物车'
      },
    },
    {
      path: '/payment',
      component: resolve => require(['@/components/companyTransfer/payment.vue'], resolve),
      meta: {
        title: '支付'
      },
    },
    {
      path: '/pay',
      name:'pay',
      component: resolve => require(['@/components/companyTransfer/pay.vue'], resolve),
      meta: {
        title: '支付宝'
      },
    },
    {
      path: '/login',
      component: resolve => require(['@/components/registerLogin/login.vue'], resolve),
      meta: {
        title: '登录'
      },
    },
    {
      path: '/register',
      component: resolve => require(['@/components/registerLogin/register.vue'], resolve),
      meta: {
        title: '注册'
      },
    },
    {
      path: '/forgetPass',
      component: resolve => require(['@/components/registerLogin/forgetPass.vue'], resolve),
      meta: {
        title: '登录'
      },
    },
    {
      path: '*',
      component: resolve => require(['@/components/common/error.vue'], resolve),
      meta: {
        title: '报错页'
      },
    },
    {
      path: '/home',
      component: resolve => require(['@/components/personalCenter/home.vue'], resolve),
      meta: {
        title: 'home'
      },
      children:[
        {
          path: '/home',
          redirect: '/center'
        },
        {
          path: '/center',
          component: resolve => require(['@/components/personalCenter/center.vue'], resolve),
          meta: {
            title: '个人中心'
          },
        },
        {
          path: '/mySite',
          component: resolve => require(['@/components/personalCenter/mySite.vue'], resolve),
          meta: {
            title: '我的设置'
          },
        },
        {
          path: '/myOrder',
          component: resolve => require(['@/components/personalCenter/myOrder.vue'], resolve),
          meta: {
            title: '订单中心'
          },
        },
        {
          path: '/orderList',
          component: resolve => require(['@/components/personalCenter/orderList.vue'], resolve),
          meta: {
            title: '订单中心'
          },
        },
        {
          path: '/myCompany',
          component: resolve => require(['@/components/personalCenter/myCompany.vue'], resolve),
          meta: {
            title: '我的公司'
          },
        },
        {
          path: '/myService',
          component: resolve => require(['@/components/personalCenter/myService.vue'], resolve),
          meta: {
            title: '我的服务'
          },
        },
        {
          path: '/coupon',
          component: resolve => require(['@/components/personalCenter/coupon.vue'], resolve),
          meta: {
            title: '优惠券'
          },
        },
        {
          path: '/viewReport',
          component: resolve => require(['@/components/personalCenter/viewReport.vue'], resolve),
          meta: {
            title: '查看报表'
          },
        },
        {
          path: '/myRecommend',
          component: resolve => require(['@/components/personalCenter/myRecommend.vue'], resolve),
          meta: {
            title: '我的推荐'
          },
        },
        {
          path: '/complaint',
          component: resolve => require(['@/components/personalCenter/complaint.vue'], resolve),
          meta: {
            title: '投诉建议'
          },
        },
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js